import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProfileDropdown from 'components/navbar/top/ProfileDropdown';
import AppContext from 'context/Context';
import React, { useContext } from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import NineDotMenu from './NineDotMenu';
import NotificationDropdown from './NotificationDropdown';
import ClockNav from 'components/ClockNav';
import { useEffect } from 'react';
import { useState } from 'react';

const TopNavRightSideNavItem = () => {


  const [clientTimezone, setClientTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

  useEffect(() => {
    const getClientTimezone = () => {
      setClientTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    };

    getClientTimezone(); 
    const timezoneChangeListener = () => {
      getClientTimezone();
    };

    window.addEventListener('timezonechange', timezoneChangeListener);

    return () => {
      // Remove the listener when the component unmounts
      window.removeEventListener('timezonechange', timezoneChangeListener);
    };
  }, []);

  const {
    config: { isDark, isRTL },
    setConfig
  } = useContext(AppContext);
  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
        {/* <ClockNav timezone={clientTimezone} /> */}
    
      <Nav.Item as={'li'}>
        <Nav.Link
          className="px-2 theme-control-toggle"
          onClick={() => setConfig('isDark', !isDark)}
        >
          <OverlayTrigger
            key="left"
            placement={isRTL ? 'bottom' : 'left'}
            overlay={
              <Tooltip style={{ position: 'fixed' }} id="ThemeColor">
                {isDark ? 'Switch to light theme' : 'Switch to dark theme'}
              </Tooltip>
            }
          >
            <div className="theme-control-toggle-label">
              <FontAwesomeIcon
                icon={isDark ? 'sun' : 'moon'}
                className="fs-0"
              />
            </div>
          </OverlayTrigger>
        </Nav.Link>
      </Nav.Item>

      <NotificationDropdown />
      {/* <NineDotMenu /> */}
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
